import { DataService } from '@api/index'

export default {
  getData(context, params) {
    const SERVICE = new DataService(params.namespace)
    return new Promise((resolve, reject) => {
      return SERVICE.get(params)
        .then(response => {
          resolve(response.data.result)
        })
        .catch(err => reject(err))
    })
  },
  create(context, params) {
    const SERVICE = new DataService(params.namespace)
    return new Promise((resolve, reject) => {
      return SERVICE.create(params)
        .then(response => {
          resolve(response.data.result)
        })
        .catch(err => reject(err))
    })
  },
  update(context, params) {
    const SERVICE = new DataService(params.namespace)

    return new Promise((resolve, reject) => {
      SERVICE.update(params)
        .then(response => resolve(response.data.result))
        .catch(reject)
    })
  },
  deleteSingle(context, params) {
    const SERVICE = new DataService(params.namespace)
    return new Promise(resolve => {
      return SERVICE.delete(params).then(response => {
        resolve(response.data.result)
      })
    })
  },
  getCreateFormData(context, params) {
    const SERVICE = new DataService(params.namespace)
    return new Promise((resolve, reject) => {
      return SERVICE.getCreateFormData(params)
        .then(response => {
          context.commit('updateCreateFormData', {
            namespace: params.namespace,
            value: response.data.result
          })
          resolve(response.data.result)
        })
        .catch(err => reject(err))
    })
  }
}
